import AgricultureStatsPropertyView from "./AgricultureStatsPropertyView";
import { SaleResult } from "types/agriculture/states-type";
import AgricultureStatsSectionView from "./AgricultureStatsSectionView";
import If from "components/common/If";

const AgricultureStatsSales = (props: { sales: SaleResult | undefined | null, forceShow?: boolean, showIncome?: boolean}) => {

    if (!props.sales && !props.forceShow) {
        return <></>;
    }

    return <AgricultureStatsSectionView title="agriculture.stats.sales">
        <div className="flex flex-wrap">
            <If condition={props.showIncome}>
                <AgricultureStatsPropertyView label="agriculture.stats.income" value={props.sales?.totalIncome} propertyType="money" />
            </If>
            <AgricultureStatsPropertyView label="agriculture.stats.kg" value={props.sales?.totalKg} propertyType="wight" />
            <AgricultureStatsPropertyView label="agriculture.stats.price-per-kg" value={props.sales?.pricePerKg} propertyType="wight" />
            <AgricultureStatsPropertyView label="agriculture.stats.interactions" value={props.sales?.totalCount} propertyType="number" />
        </div>
        <div className="flex flex-wrap">
            <AgricultureStatsPropertyView label="agriculture.stats.kg-per-sale" value={props.sales?.kgPerSale} propertyType="wight" />
            <AgricultureStatsPropertyView label="agriculture.stats.carts" value={props.sales?.totalCart} propertyType="number" />
            <AgricultureStatsPropertyView
                label="agriculture.stats.kg-per-cart"
                value={props.sales?.kgPerCart}
                propertyType="wight"
            />
            <AgricultureStatsPropertyView label="agriculture.stats.carts-per-sale" value={props.sales?.cartPerSale} propertyType="number" />
        </div>
    </AgricultureStatsSectionView>
};

export default AgricultureStatsSales;
